import {MDIcon} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {paths} from '@mintdata-wsp/wsp/ui/routes/Routing';
import {TopBarUserIconList} from '@mintdata-wsp/wsp/ui/views/visualDesigner/header/userPresence/TopBarUserIconList';
import {UserIconSize} from '@mintdata-wsp/wsp/ui/views/visualDesigner/header/userPresence/UserIcon';
import {SettingsRoutes} from '@mintdata-wsp/wsp/ui/views/workspace/settings/SettingsPanel';
import {HelpCenterButton} from '@mintdata-wsp/wsp/ui/views/workspace/userBar/HelpCenterButton';
import {ProfileButton} from '@mintdata-wsp/wsp/ui/views/workspace/userBar/profile/ProfileButton';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./UserBar.less');
const cx = classnames.bind(styles);

export interface UserBarProps
{
    className?:string;
}

@observer
export class UserBar extends React.Component<UserBarProps, any>
{
    // _renderCurrentOrgName()
    // {
    //     if( !controllers.user.isLoggedIn() )
    //         return null;
    //
    //     return <Row className={cx('organizationName')}>{rootState.userSession.currentOrganization.name}</Row>;
    // }

    private _ocClickBtnShare = (e:React.MouseEvent<HTMLElement>) =>
    {
        e.preventDefault();
        controllers.navigation.navigateTo(
            `${paths.settings()}/${SettingsRoutes.Members}`,
            {openAddPeopleDialog: true}
        );
    };

    public componentDidMount()
    {
        const {activeUsersSync} = controllers.ui;
        activeUsersSync.startSyncWSPUsers();
    }

    public componentWillUnmount()
    {
        const {activeUsersSync} = controllers.ui;
        activeUsersSync.stopSyncWSPUsers();
    }

    render()
    {
        let {className} = this.props;

        return (
            <Row className={cx('userBar', className)}>
                {/*{this._renderCurrentOrgName()}*/}
                {/*<OrganizationSwitcher className={cx('organizationSwitcher')} />*/}

                <TopBarUserIconList
                    iconSize={UserIconSize.Large}
                    className={cx('wsp')}
                    wspMode
                    userIconContainerClassName={styles.userIconContainer}
                />

                <div
                    className={styles.btnShare}
                    onClick={this._ocClickBtnShare}
                >
                    <MDIcon
                        className={styles.btnShareIcon}
                        name={MDIcons.common.PeopleAdd}
                    />
                    <span className={styles.btnShareTitle}>
                        Share
                    </span>
                </div>

                <ProfileButton
                    className={styles.profileButton}
                    captionClassName={styles.profileButtonCaption}
                />

                <HelpCenterButton />
                {/*<TopBarDotButton />*/}

            </Row>
        );
    }
}
